module.exports = __webpack_public_path__ + "files/3e9e27f043e770a8690883e26599133f.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Typewriter-Regular.woff
// module id = 991
// module chunks = 60